// MARK: Helper functions for building URLs

// Centralised URL settings — move to env/remote-config when ready
const URL_SETTINGS = {
  payerLocal: 'http://localhost:8088',
  payerProd: 'https://pay.strikepay.co',
};

// Before app.striketip.com goes live, complete these manual steps:
//  1. Firebase Console > Authentication > Settings > Authorized domains — add app.striketip.com
//  2. Firebase Console > Hosting — add app.striketip.com as a custom domain
//  3. DNS: CNAME app.striketip.com → Firebase Hosting
export const APP_DOMAINS = {
  tip: 'app.striketip.com',
  legacy: 'app.strikepay.co',
};

export function isStriketipDomain() {
  const host = window.location.hostname;
  return host === APP_DOMAINS.tip || host === 'localhost';
}

export function getAppBaseUrl() {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return `${window.location.protocol}//${host}:${window.location.port || '3000'}`;
  }
  if (host === APP_DOMAINS.tip) return `https://${APP_DOMAINS.tip}`;
  return `https://${APP_DOMAINS.legacy}`;
}

export function getAppDomain() {
  const host = window.location.hostname;
  if (host === APP_DOMAINS.tip) return APP_DOMAINS.tip;
  return APP_DOMAINS.legacy;
}

function getQueryStringForParams(params) {
  var query = Object.keys(params)
    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&');
  return query;
}

export function getPayerBaseUrl() {
  const isLocalHost = window.location.hostname === 'localhost';
  return isLocalHost ? URL_SETTINGS.payerLocal : URL_SETTINGS.payerProd;
}

/**
 * @deprecated The "My" surface is being retired. Auth is shared between pay. and app.
 * Points to pay.strikepay.co now. Callers should migrate to getPayerBaseUrl().
 */
export function getMyBaseUrl() {
  return getPayerBaseUrl();
}

/**
 * Smart POS payment link on the payer origin. The whole payment context travels
 * in the query, using the params the payer already parses: amountMinor is in
 * MINOR units (cents/pence), tmid selects a member, team=true means whole-team,
 * ttitle titles the t= amount (the POS service description — its own tap
 * field, never paymentInfo, which stays free for the payer's own message).
 * Links are stateless — any number can be in flight at once.
 */
function applyPosPaymentParams(url, {
  amountMinor, totalMinor, tmid, customerPicks, name, serviceDescription,
}) {
  // URL/searchParams keep the link canonical — no trailing "?" when empty.
  if (amountMinor) url.searchParams.set('amount', amountMinor);
  // Service total (minor units): percentage tips are computed off it, and it
  // gives reporting one consistent view of the underlying bill.
  if (totalMinor) url.searchParams.set('t', totalMinor);
  // Member routing: tmid targets one member; team=true is a whole-team tip;
  // neither => the payer sees the member selection page ("customer picks").
  if (tmid) url.searchParams.set('tmid', tmid);
  else if (!customerPicks) url.searchParams.set('team', 'true');
  if (name) url.searchParams.set('name', name);
  if (serviceDescription) url.searchParams.set('ttitle', serviceDescription);
  return url.toString();
}

export function posPaymentUrl(tagId, opts) {
  return applyPosPaymentParams(new URL(`${getPayerBaseUrl()}/tags/${tagId}`), opts || {});
}

/** PNG of the same link, served by the payer's stateless QR endpoint. */
export function posPaymentQRUrl(tagId, opts) {
  return applyPosPaymentParams(new URL(`${getPayerBaseUrl()}/qr/${tagId}/png`), opts || {});
}

export function paymentUrl(tagId, amount, name, reference) {
  const urlBase = getPayerBaseUrl();
  const tagUrl = `${urlBase}/tags/${tagId}?`;
  let params = {};

  if (amount) params.amount = amount;
  if (name) params.name = name;
  if (reference) params.reference = reference;

  var query = getQueryStringForParams(params);

  return (tagUrl + query);
}


export function shareUrl(tag, refId) {
  const urlBase = getPayerBaseUrl();
  let params = {};
  let tagId = tag.id;
  const typeLink = "tags";

  if (tag.templateTagId && tag.tagUid)  {
    tagId = tag.templateTagId;
    params.uid = tag.tagUid;
  }

  if (refId) params.refId = refId;

  const query = getQueryStringForParams(params);
  let tagUrl = `${urlBase}/${typeLink}/${tagId}`;

  if (query.length > 0) {
    tagUrl = `${tagUrl}?`;
  }
  return (tagUrl + query);
};

export function shareQRUrl(tag, refId) {
  const urlBase = getPayerBaseUrl();
  let params = {};
  let tagId = tag.id;
  const typeLink = "qr";

  if (tag.templateTagId && tag.tagUid)  {
    tagId = `${tag.templateTagId}---${tag.tagUid}`;
  }

  if (refId) params.refId = refId;

  const query = getQueryStringForParams(params);
  const tagUrl = `${urlBase}/${typeLink}/${tagId}?`;
  return (tagUrl + query);
};
